import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { toast } from 'react-hot-toast'

import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'

import { ServiceLevelTable } from './ServiceLevel.Table'
import { useServiceLevel, useUpdateServiceLevel } from './ServiceLevel.data'

export const ServiceLevelView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state

  const { data: serviceLevelData, isLoading } = useServiceLevel({
    projectId,
    scenarioId,
  })

  const handleUpdateSuccess = () => {
    toast.success('Service level updated successfully')
  }

  const handleUpdateError = (error: unknown) => {
    const reason = (error as { response?: { data?: { error?: string } } })
      ?.response?.data?.error
    toast.error(
      reason?.includes('serviceLevel')
        ? 'Service level must be between 0 % and 100 %'
        : 'Failed to update service level'
    )
  }

  const { mutate: updateServiceLevel, isPending: isUpdating } =
    useUpdateServiceLevel({
      projectId,
      scenarioId,
      onSuccess: handleUpdateSuccess,
      onError: handleUpdateError,
    })

  return (
    <SettingsPage title="Service level">
      <ServiceLevelTable
        data={serviceLevelData ?? []}
        isLoading={isLoading}
        updateTableData={updateServiceLevel}
        isSaving={isUpdating}
      />
    </SettingsPage>
  )
}
